import React from 'react';
import { BORDER, CARD, TEXT_MUTED, TEXT_PRIMARY } from './tokens';

/**
 * Titled panel.
 *
 * Screens wrapped content in a card and then hand-rolled a heading row above
 * it, with padding varying between p-4, p-5 and p-6 for the same kind of
 * panel. One shape, one padding.
 */
const SectionCard = ({ title, description, actions, children, padded = true, className = '' }) => (
  <section className={`${CARD} ${className}`}>
    {(title || actions) && (
      <div className={`flex items-start gap-4 px-5 py-4 ${children ? `border-b ${BORDER}` : ''}`}>
        <div className="min-w-0 flex-1">
          {title && <h2 className={`text-sm font-semibold ${TEXT_PRIMARY}`}>{title}</h2>}
          {description && <p className={`text-[13px] mt-0.5 ${TEXT_MUTED}`}>{description}</p>}
        </div>
        {actions && <div className="flex items-center gap-2 flex-shrink-0">{actions}</div>}
      </div>
    )}
    {children && <div className={padded ? 'p-5' : ''}>{children}</div>}
  </section>
);

export default SectionCard;
